module.exports = __webpack_public_path__ + "img/1526636914.e774844d.jpg";